<template>
  <li class="nav_item">
    <component :is="as" :target="target" :href="href"
               :class="{'active': active, 'nav_link': !sub, 'nav_sublink': sub}">
      <slot>
        <svg v-if="icon" class="nav_icon">
          <use :xlink:href="'#'+icon"></use>
        </svg>
        <span v-if="label" class="label">{{ label }}</span>
      </slot>
    </component>
  </li>
</template>

<script>
export default {
  name: "SidebarMenuItem",

  props: {
    routeTo: {
      type: [String, Object],
      required: true,
    },

    icon: {
      type: String,
      default: null
    },

    label: {
      type: String,
      default: null
    },

    active: {
      type: Boolean,
      default: false
    },

    sub: {
      type: Boolean,
      default: false
    },

    external: {
      type: Boolean,
      default: false
    },

    target: {
      type: String,
      default: null
    },

    as: {
      type: String,
      default: 'inertia-link'
    }
  },

  computed: {
    routeName() {
      return this.routeTo['name'] ?? this.routeTo
    },

    routeParams() {
      return this.routeTo['params'] ?? {}
    },

    href() {
      return this.external
        ? this.routeTo
        : this.route(this.routeName, this.routeParams);
    }
  }
}
</script>
